import clsx from 'clsx';

//hooks
import { useTransformStringOnOffset } from '@/utils/hooks/format/useTransformString';

import PropTypes from 'prop-types';

import { DEFAULT_POST_CONFIG } from '@/lib/posts/defaultPostConfig';
import { FB_POST_TYPES, getPostType, POST } from '@/lib/posts/postTypes';
//lib
import { FACEBOOK } from '@/lib/socialProfile';

//components
import Post from '@/components/base/Post';
import HoverLabelAndAlbums from '@/components/base/Post/HoverLabelAndAlbums';

const FacebookPost = ({
    data,
    isLoading,
    config,
    openViewer,
    handleLabelsEvent,
    handleAlbumsEvent,
    postConfig = { hasHover: true, hasFooter: true, showLabels: true, showAlbums: true },
    remoteMedia = false,
    feedType = null,
    isExport = false,
    showHeader = true,
    ...restProps
}) => {
    const type = getPostType({
        network: FACEBOOK,
        type: data?.type,
        mediasLength: data?.medias?.length
    });
    const mergedPostConfig = { ...DEFAULT_POST_CONFIG, ...postConfig };
    const { OffsetReplace, formatFacebookText } = useTransformStringOnOffset();

    if (isLoading) {
        return <Post.Placeholder postType={POST} isExport={isExport} />;
    }

    return (
        <div className="w-full">
            {showHeader && <Post.Header data={data} isExport={isExport} />}
            <Post
                data={data}
                config={config}
                isLoading={isLoading}
                isExport={isExport}
                className={clsx('w-full bg-white', {
                    'p-0.5': !mergedPostConfig?.hasFooter,
                    'px-2 pt-2': mergedPostConfig?.hasFooter,
                    'dark:bg-icoDarkMode-anthracite': !isExport
                })}
                {...restProps}>
                {({ referenceElement }) => (
                    <>
                        <Post.Content className="w-full">
                            {mergedPostConfig?.hasHover ? (
                                <HoverLabelAndAlbums
                                    openViewer={openViewer}
                                    referenceElement={referenceElement}
                                    handleLabelsEvent={handleLabelsEvent}
                                    handleAlbumsEvent={handleAlbumsEvent}
                                    showLabels={mergedPostConfig?.showLabels}
                                    showAlbums={mergedPostConfig?.showAlbums}
                                    socialProfile={data?.social_profile}
                                />
                            ) : null}
                            {type &&
                            type !== FB_POST_TYPES.TYPE_STATUS &&
                            type !== FB_POST_TYPES.TYPE_PHOTO ? (
                                <Post.PostTypeIcon type={type} isExport={isExport} />
                            ) : null}
                            {data?.promoted_post ? (
                                <div className="absolute left-1 top-1 flex flex-col space-y-1.5">
                                    <Post.Promoted />
                                </div>
                            ) : null}
                            {(type === FB_POST_TYPES.TYPE_STATUS && data?.caption !== '') ||
                            (type === FB_POST_TYPES.TYPE_PHOTO &&
                                data?.medias?.[0]?.type === 'link' &&
                                !data?.medias?.[0]?.image) ? (
                                <Post.Status
                                    remoteMedia={remoteMedia}
                                    formattedCaption={
                                        data?.medias?.[0]?.type === 'link' &&
                                        data?.caption === '' ? (
                                            data?.medias?.[0]?.target ?? ''
                                        ) : (
                                            <OffsetReplace
                                                text={formatFacebookText(
                                                    data?.caption,
                                                    data?.tags,
                                                    'span'
                                                )}
                                                components={{
                                                    span: <span className="text-icoBlue" />,
                                                    br: <br />,
                                                    p: <p />
                                                }}
                                            />
                                        )
                                    }
                                />
                            ) : (
                                <div className="square">
                                    <Post.Image remoteMedia={remoteMedia} />
                                </div>
                            )}
                        </Post.Content>
                        {mergedPostConfig?.hasFooter ? (
                            <Post.Footer feedType={feedType} type={type} />
                        ) : null}
                    </>
                )}
            </Post>
        </div>
    );
};

FacebookPost.propTypes = {
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    config: PropTypes.object,
    openViewer: PropTypes.func,
    addLabel: PropTypes.func,
    addAlbum: PropTypes.func
};

export default FacebookPost;
